import { FC, CSSProperties } from 'react';
import { Breakpoints, SkeletonFrame, useBreakpoint } from '@nextgen-web-framework/all';
import {
  loaderCardArray,
  loaderSkeletonConfig,
  LoaderTypeEnums,
  pickupDrawerLoaderArray,
} from '../common/config/checkoutConstants';
import { ISkeletonConfig } from '../common/types/CheckoutType';
import styles from './CheckoutPageLoader.module.scss';
import { ICheckoutPageLoaderProps } from './types/propTypes';

export const CheckoutPageLoader: FC<ICheckoutPageLoaderProps> = ({ topbar, loaderType }: ICheckoutPageLoaderProps) => {
  const loaderClassName = loaderType != LoaderTypeEnums.FULL_PAGE && `checkout-loader-wrapper-for-${loaderType}`;
  const viewPortType = useBreakpoint();
  const isMobileView = viewPortType == Breakpoints.XS || viewPortType == Breakpoints.SM;
  const getStyles = (skeletonProperties: ISkeletonConfig): CSSProperties => {
    const style: CSSProperties = {
      ...skeletonProperties,
    };
    return style;
  };
  const getNormalPageLoading = (loaderType?: string) => {
    const loaderArray = loaderType == LoaderTypeEnums.FULL_PAGE ? loaderCardArray : pickupDrawerLoaderArray;
    return loaderArray.map((elem) => (
      <div className={styles['checkout-loader-card']} key={elem}>
        <div className={`${styles['checkout-loader-container']} ${!elem && styles['checkout-product-container']}`}>
          <SkeletonFrame className={styles['checkout-loader-bar']} />
          <SkeletonFrame className={styles['checkout-loader-bar']} />
          {loaderType != LoaderTypeEnums.FULL_PAGE && <SkeletonFrame className={styles['checkout-loader-bar']} />}
          {!elem && loaderType == LoaderTypeEnums.FULL_PAGE && (
            <>
              <div className={styles['checkout-loader-bar']}>
                <div className={styles['product-card-loader']}>
                  <SkeletonFrame className={styles['product-loader-left-content']} />
                  <div className={styles['product-loader-right-content']}>
                    <SkeletonFrame
                      className={`${styles['checkout-loader-bar']} ${styles['product-loader-right-top-content']}`}
                    />
                    <SkeletonFrame
                      className={`${styles['checkout-loader-bar']} ${styles['product-loader-right-bottom-content']}`}
                    />
                  </div>
                </div>
              </div>{' '}
            </>
          )}
        </div>
      </div>
    ));
  };

  const getConfigBasedPageLoading = () =>
    loaderSkeletonConfig.map((containerArr) => (
      <div className={styles['checkout-loader-card']} key={containerArr.id}>
        <div style={getStyles(containerArr)} className={styles['checkout-loader-container']}>
          {!isMobileView &&
            containerArr.skeltonFrames.map((skeletonFrame) => (
              <div key={skeletonFrame.id} style={getStyles(skeletonFrame)}>
                <SkeletonFrame heightValue={skeletonFrame.height} className={styles['checkout-loader-bar']} />
              </div>
            ))}
          {isMobileView &&
            containerArr.mobileSkeltonFrames.map((skeletonFrame) => (
              <div key={skeletonFrame.id} style={getStyles(skeletonFrame)}>
                <SkeletonFrame heightValue={skeletonFrame.height} className={styles['checkout-loader-bar']} />
              </div>
            ))}
        </div>
      </div>
    ));

  const getLoaderGrids = (withVariation?: boolean) => (
    <div
      className={
        !withVariation
          ? styles['checkout-loader-card-group']
          : `${styles['checkout-loader-card-group']} ${styles['checkout-loader-card-group-variation']}`
      }
    >
      {loaderType == LoaderTypeEnums.FULL_PAGE && !withVariation
        ? getConfigBasedPageLoading()
        : getNormalPageLoading(loaderType)}
    </div>
  );
  return (
    <div className={!loaderClassName ? styles['checkout-loader-wrapper'] : `${styles[loaderClassName]}`}>
      {topbar && <div className={styles['checkout-loader-top-bar']}></div>}
      <div className={styles['checkout-loader-card-wrapper']}>
        {getLoaderGrids()}
        {getLoaderGrids(true)}
      </div>
    </div>
  );
};

export default CheckoutPageLoader;
